import JshModule from '@core/scripts/helper/jsh-module';
import {Slider} from '../../components/slider.js';

const MEDIUM_BREAKPOINT = 480;
const LARGE_BREAKPOINT = 768;

do {
  /** @var {{ moduleScope: HTMLElement,
   * config?: {
   *    itemsPerSlideLarge: number,
   *    itemsPerSlideMedium?: number,
   *    itemsPerSlideSmall: number,
   *    teaserId: string,
   *    page: string,
   *    shopId: number,
   *    teaserType: string
   * }}} **/
  const {moduleScope, config} = JshModule('teaser/slider');

  if (moduleScope !== null) {
    const itemsPerSlideSmall = config?.itemsPerSlideSmall ?? 2;
    const itemsPerSlideMedium = config?.itemsPerSlideMedium ?? itemsPerSlideSmall;
    const itemsPerSlideLarge = config?.itemsPerSlideLarge ?? 5;

    const sliderElement = moduleScope.querySelector('.content-platform__slider');

    const prevButton = moduleScope.querySelector('button.-prev');
    const nextButton = moduleScope.querySelector('button.-next');

    const slideCount = window.innerWidth < MEDIUM_BREAKPOINT ?
      itemsPerSlideSmall :
      window.innerWidth < LARGE_BREAKPOINT ?
        itemsPerSlideMedium : itemsPerSlideLarge;

    const swipeTrackingInfo = {
      teaserElementId: config?.teaserId,
      shopId: config?.shopId,
      page: config?.page,
      teaserType: config?.teaserType,
    };

    const sliderInstance = new Slider(slideCount, swipeTrackingInfo, sliderElement);

    prevButton.onclick = () => {
      sliderInstance.slideLeft(itemsPerSlideLarge);
    }

    nextButton.onclick = () => {
      sliderInstance.slideRight(itemsPerSlideLarge);
    }

  }

} while (document.querySelector('[jsh-module="teaser/slider"]') !== null);
